module.exports = __webpack_public_path__ + "static/img/lifestyle_06.2655e24e.jpg";